import React from "react";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { defaultPfpUrl } from "../utils";

/**
 * Larger view of a user or organization profile photo.
 *
 * @param {Object} props
 * @param {boolean} props.open
 * @param {(open: boolean) => void} props.onOpenChange
 * @param {string} props.src
 * @param {string} props.alt
 * @returns {JSX.Element}
 */
function ProfilePhotoModal({ open, onOpenChange, src, alt }) {
  const photoSrc = src || defaultPfpUrl;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[min(100vw-2rem,40rem)] border-0 bg-transparent p-0 shadow-none">
        <DialogHeader className="sr-only">
          <DialogTitle>{alt || "Profile photo"}</DialogTitle>
        </DialogHeader>
        <div className="relative flex items-center justify-center">
          <DialogClose
            className="absolute right-2 top-2 z-10 inline-flex h-8 w-8 items-center justify-center rounded-full bg-carousel-control text-carousel-control-fg shadow-shell-sm"
            aria-label="Close photo"
          >
            <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </DialogClose>
          <img
            src={photoSrc}
            alt={alt || "Profile photo"}
            className="max-h-[min(85vh,40rem)] max-w-full rounded-lg object-contain shadow-shell-sm"
            onError={(event) => {
              event.currentTarget.onerror = null;
              event.currentTarget.src = defaultPfpUrl;
            }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default ProfilePhotoModal;
